import { version } from "@src/env";

export function getManifestUrl(): string {
  return `/manifest.json?referer=${encodeURIComponent(window.location.href)}&version=${version}`;
}
